export var WhoCanDownload;
(function (WhoCanDownload) {
    WhoCanDownload["ANYONE"] = "ANYONE";
    WhoCanDownload["MEMBERS_ONLY"] = "MEMBERS_ONLY";
})(WhoCanDownload || (WhoCanDownload = {}));
export var LayoutOptions;
(function (LayoutOptions) {
    LayoutOptions["LIST"] = "LIST";
    LayoutOptions["THUMBNAIL"] = "THUMBNAIL";
})(LayoutOptions || (LayoutOptions = {}));
export var TextAlignment;
(function (TextAlignment) {
    TextAlignment["LEFT"] = "LEFT";
    TextAlignment["RIGHT"] = "RIGHT";
})(TextAlignment || (TextAlignment = {}));
export var LibraryItemSortBy;
(function (LibraryItemSortBy) {
    LibraryItemSortBy["CREATED_AT"] = "CREATED_AT";
    LibraryItemSortBy["NAME"] = "NAME";
    LibraryItemSortBy["TYPE"] = "TYPE";
    LibraryItemSortBy["TIMES_FAVORITED"] = "TIMES_FAVORITED";
    LibraryItemSortBy["UNIQUE_VIEWS"] = "UNIQUE_VIEWS";
    LibraryItemSortBy["LAST_MODIFIED"] = "LAST_MODIFIED";
    LibraryItemSortBy["SIZE"] = "SIZE";
})(LibraryItemSortBy || (LibraryItemSortBy = {}));
export var Orientation;
(function (Orientation) {
    Orientation["DESC"] = "DESC";
    Orientation["ASC"] = "ASC";
})(Orientation || (Orientation = {}));
export var FileIcon;
(function (FileIcon) {
    FileIcon["EXTENSION"] = "EXTENSION";
    FileIcon["CLASSIC"] = "CLASSIC";
    FileIcon["LINE"] = "LINE";
})(FileIcon || (FileIcon = {}));
export var FileCategory;
(function (FileCategory) {
    FileCategory["OTHER"] = "OTHER";
    FileCategory["MUSIC"] = "MUSIC";
    FileCategory["VIDEO"] = "VIDEO";
    FileCategory["IMAGE"] = "IMAGE";
    FileCategory["DOCS"] = "DOCS";
    FileCategory["FONT"] = "FONT";
})(FileCategory || (FileCategory = {}));
//# sourceMappingURL=types.impl.js.map